import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, SimpleList, FunctionField, useRefresh, Button as RaButton
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, IconButton, Button
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import queryString from 'query-string';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import CustomFilter from './components/CustomFilter';
import EditIcon from '@material-ui/icons/Edit';
import { Link } from "react-router-dom";
import DehazeIcon from '@material-ui/icons/Dehaze';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import ControllerImg from './images/controllerImg.png';
import CustomDeleteButton from './CustomDeleteButton';
import CustomCreateButton from './components/CustomCreateButton';
import RaEditableTextFieldV2 from './components/RaEditableTextFieldV2';
import DownloadIcon from "@material-ui/icons/GetApp";
// import ReplayIcon from '@material-ui/icons/Replay';
// import config from './config.json';
// import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
});
const CATEGORY = "CONTROLLER SECTION"

export const ControllersList = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [role] = useState(sessionStorage.getItem("role"));
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [listData, setListData] = useState([])
    const [allRecords, setAllRecords] = useState([])
    const [gridListToggle, setGridListToggle] = React.useState(true)
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Name"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState("Name");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            filterType: "Gate",
            dataList: [{ name: "ENTRY", id: 1 }, { name: "EXIT", id: 2 }, { name: "BOTH", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Status",
            dataList: [{ name: "Online", id: 1 }, { name: "Offline", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const renderStatus = record => (
        <>
            {
                record ?
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: record.Status === "Online" ? `${customTheme.palette.primary.main}19` : `${customTheme.palette.error.main}19`, marginRight: 8 }}>
                            <div className={classes.statusCircle} style={{ backgroundColor: record.Status === "Online" ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
                        </div>
                        <p>{record.Status}</p>
                    </div>
                    :
                    <div style={{ display: 'flex', alignItems: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#9597991a", marginRight: 8 }}>
                        <div className={classes.statusCircle} style={{ backgroundColor: "#1717181f" }} />
                    </div>
            }
        </>
    );

    const download = (url) => {
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = `${url}?time=${Date.now()}`;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

    // const resetControllerStatus = () => {
    //     const token = sessionStorage.getItem('token');
    //     fetch(`${config.HOST_NAME}/crm/resetControllerStatus`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${token}`
    //         },
    //     })
    //         .then(response => response.json())
    //         .then(json => notify(json.success ? "Successfullly refreshed" : json.message, json.success ? "success" : "warning"))
    //         .catch((error) => {
    //             console.log(error)
    //             notify("Something went wrong", "warning")
    //         });
    // }

    useEffect(() => {
            setAllRecords((prev) => {
                let temp = Object.keys(listData).length !== 0 ? [...Object.values(listData)].reverse() : []
                console.log(temp.reverse())
                return temp
            })
    }, [listData])

    useEffect(() => {
        eventTracker(CATEGORY, " CONTROLLER LIST")
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Gate") {
                    values = { ...values, action: filterListValue[val].value ? filterListValue[val].value : undefined }
                } if (filterListValue[val].filterType === "Status") {
                    values = { ...values, status: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
    }, [props]);

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            {/* {role === 'admin' && <Button className='buttonStyle addBorderRadius' variant='contained' color="secondary" disableElevation onClick={resetControllerStatus} title='Refresh Unit Id'>
                <ReplayIcon style={{ fontSize: "20px" }} />
            </Button>} */}
            {!viewOnly && role === "admin" && <CustomCreateButton label="Create Controller" basePath="controllers" />}
            <div style={{ backgroundColor: "#F5F8FA", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Button className={gridListToggle === true ? 'buttonStyle addBorderRadius primaryBgColor lightGrayBlueColor' : 'buttonStyle addBorderRadius cloudyBlueColor'} variant='contained' disableElevation onClick={() => setGridListToggle(true)}>
                    <DehazeIcon />
                </Button>
                <Button className={gridListToggle === false ? 'buttonStyle addBorderRadius primaryBgColor lightGrayBlueColor' : 'buttonStyle addBorderRadius cloudyBlueColor'} variant='contained' disableElevation onClick={() => setGridListToggle(false)}>
                    <BorderAllIcon />
                </Button>
            </div>
        </div>
        <List
            {...props}
            style={{ marginTop: 10 }}
            title="Controllers"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => setListData(listData.data)} trackUpdatedListData={true} />}
        >
            {isSmallDevice ?
                <>
                    {
                        gridListToggle &&
                        <SimpleList
                            primaryText={record => record["device_id"]}
                            secondaryText={record => (<div>
                                {record.Status && <div style={{ color: record.Status === "Online" ? customTheme.palette.primary.main : customTheme.palette.error.main }}><span style={{ color: "#5a5a5a" }}>Status: </span>{record.Status}</div>}
                                {record.LastOnlineTime && <div><span style={{ color: "#5a5a5a" }}>Last Seen: </span>{moment(record["LastOnlineTime"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm:ss A")}</div>}
                                {record.device_id && <div><span style={{ color: "#5a5a5a" }}>Type: </span>Controller</div>}
                                {record.action && <div style={{ color: record.Status === "Online" ? customTheme.palette.primary.main : customTheme.palette.error.main }}><span style={{ color: "#5a5a5a" }}>Gate: </span>{record.action}</div>}
                                <div><span style={{ color: "#5a5a5a" }}>Gate Description: </span>{record.gate_id ? record.gate_id : "Default"}</div>
                                {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Place: </span>{record.parking_name}</div>}
                                {!viewOnly && role === 'admin' &&
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Link to={`/controller/edit/${record.device_id}`} style={{ textDecoration: "none" }}>
                                            <IconButton>
                                                <EditIcon style={{ color: "#18cc69" }} />
                                            </IconButton>
                                        </Link>
                                        <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/parkingController'} />
                                        <RaButton onClick={() => download(`https://files.parksmart.in/main/Controller/${record.device_id}/settings.json`)} style={{ color: "#334d6e" }} label={false} className={classes.deleteButton}>
                                            <DownloadIcon />
                                        </RaButton>
                                    </div>
                                }
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                    }
                    {gridListToggle === false &&
                        <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 480px))", width: "100%", gap: 20, justifyContent: "center" }}>

                            {allRecords[0] && allRecords.map((device) => {
                                return <DeviceStatusCard notes={device.Notes} action={device.action} device_id={device.device_id} status={device.Status} lastSeen={device.LastOnlineTime} isSmallDevice={isSmallDevice} role={role} />
                            })}

                        </div>
                    }
                </>
                :
                <>
                    {
                        gridListToggle &&
                        <Datagrid className={!viewOnly ? 'controllerDataGrid customStyleDataGrid' : 'customStyleDataGrid'} component={ScrollableTable}>
                            <FunctionField source='device' label="Device" render={record => record && <img height="50" width="45" src={ControllerImg} alt="Controller" />} />
                            <FunctionField source='device_id' label="Name" render={record => record && record["Name"] ?
                                <div>
                                    <div className='logsTableDataColor1 fontWeightBold'>{record["Name"]}</div>
                                </div>
                                : "-"
                            }
                            />
                            <FunctionField
                                source="Status"
                                label="Status"
                                render={record => record && renderStatus(record)}
                            />
                            <FunctionField source="LastOnlineTime" label="Last Seen" render={record => record && record["LastOnlineTime"] ?
                                <div>
                                    <div className='logsTableDataColor1 fontWeightBold'>{moment(record["LastOnlineTime"]).format("hh:mm A")}</div>
                                    <div className='logsTableDataColor2 fontWeightMedium'>{moment(record["LastOnlineTime"]).format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />
                            <FunctionField source='device_id' label="Type" render={record => "Controller"} />
                            <RaEditableTextFieldV2 source="gate_id" label="Gate" />
                            <FunctionField label="Lane" render={record => record && record.lane ? record.lane : '-'} />
                            <FunctionField source='action' label="Action" render={record => record && <span style={{ color: record.Status === 'Online' ? "#18cc69" : "#de575e", fontWeight: "bold" }}>{record.action}</span>} />
                            <FunctionField source="my_gate_last_synced_on" label="Last Synced With MG" render={record => record && record["my_gate_last_synced_on"] && record["my_gate_last_synced_on"] !== "0" ?
                                <div>
                                    <div className='logsTableDataColor1 fontWeightBold'>{moment.unix(record["my_gate_last_synced_on"]).format("hh:mm A")}</div>
                                    <div className='logsTableDataColor2 fontWeightMedium'>{moment.unix(record["my_gate_last_synced_on"]).format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />
                            {/* <FunctionField source="request" label="Request" render={record =>
                                <Button className='buttonStyle addBorderRadius secondaryBgColor whiteColor tableButtonHeight fontWeightSemiBold' variant='contained' disableElevation title='Request'>
                                    Request
                                </Button>
                            }
                            /> */}
                            {/* <TextField source="parking_name" label="Place" /> */}
                            {!viewOnly && role === 'admin' &&
                                <FunctionField className="ListIconsContainerController" render={record => record &&
                                    <div className="ListIcons">
                                        <Link to={`/controller/edit/${record.device_id}`} style={{ textDecoration: "none" }}>
                                            <Button>
                                                <EditIcon style={{ color: "#18cc69", fontSize: 20 }} />
                                            </Button>
                                        </Link>
                                        <div>
                                            <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/parkingController'} />
                                        </div>
                                        <RaButton onClick={() => download(`https://files.parksmart.in/main/Controller/${record.device_id}/settings.json`)} style={{ color: "#334d6e" }} label={false} className={classes.deleteButton}>
                                            <DownloadIcon />
                                        </RaButton>
                                    </div>
                                } />
                            }
                        </Datagrid>
                    }

                    {gridListToggle === false &&
                        <div style={{ padding: isSmallDevice ? "0 22px 25px" : "0px", marginTop: 20, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 480px))", width: "100%", gap: 20, justifyContent: "center" }}>

                            {allRecords[0] && allRecords.map((device) => {
                                return <DeviceStatusCard notes={device.Notes} action={device.action} device_id={device.device_id} status={device.Status} lastSeen={device.LastOnlineTime} isSmallDevice={isSmallDevice} role={role} />
                            })}
                        </div>
                    }
                </>
            }
        </List>
    </div>
};

const DeviceStatusCard = (props) => {
    const classes = useStyles();
    const { action, device_id, status, isSmallDevice, role } = props;
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");

    const StatusIndicator = (status) => (
        <>
            {
                status ?
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: status === "Online" ? `${customTheme.palette.primary.main}19` : `${customTheme.palette.error.main}19`, marginRight: 8 }}>
                            <div className={classes.statusCircle} style={{ backgroundColor: status === "Online" ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
                        </div>
                    </div>
                    :
                    <div style={{ display: 'flex', alignItems: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#9597991a", marginRight: 8 }}>
                        <div className={classes.statusCircle} style={{ backgroundColor: "#1717181f" }} />
                    </div>
            }
        </>
    );
    return (
        <div style={{ fontFamily: "Poppins-Medium" }}>
          {!viewOnly && role === "admin" &&  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {/* <Typography>{notes}</Typography> */}
                 <Link style={{ textDecoration: "none" }} to={`/controller/edit/${device_id}`}><Button startIcon={<EditIcon />} size='small' variant='outlined' color='primary'>Edit</Button></Link>
            </div>}
            <div variant="outlined" style={{ display: "flex", justifyContent: "space-evenly", alignItems: "flex-start", fontFamily: "Poppins-Medium", padding: "24px 20px", backgroundColor: "#F4F8FB", borderRadius: 10, marginTop: "15px" }}>
                <div>
                    <img height="120" width="110" src={ControllerImg} alt="Controller" />
                </div>
                <div>
                    <div className='fontWeightSemiBold' style={{ fontSize: 14, color: "#323C47" }}>
                        Controller
                    </div>
                    <div style={{ display: "flex", columnGap: 20 }}>
                        <div className='fontWeightMedium' style={{ fontSize: 12, color: "#6A707E" }}>
                            <p>Name:</p>
                            <p>Power:</p>
                            <p>Status:</p>

                        </div>
                        <div className='secondaryColor fontWeightMedium' style={{ fontSize: 12 }}>
                            <p>{device_id}</p>
                            <p>{status === "Online" ? "On" : "Off"}</p>
                            <p>{StatusIndicator(status)}</p>
                        </div>
                    </div>
                </div>
                {!isSmallDevice &&
                    <div className='addBorderRadius' style={{ display: "flex", alignSelf: "flex-start", fontSize: 12, padding: "4px 15px", fontFamily: "Poppins-SemiBold", color: status === "Online" ? "#18cc69" : "#cc2418", backgroundColor: status === "Online" ? "#18cc6919" : "#cc241819" }}>
                        <div>{action}</div>
                    </div>
                }
            </div>
        </div>
    );
}